import React from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import useMediaQuery from '@mui/material/useMediaQuery'

import {useNavigate} from 'react-router-dom'

import {connect} from 'react-redux'

import {create, destroy, showAlert} from '../../../actions'

import {day, formatDate} from '../../../utils'

import Button from '@mui/material/Button'
import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import FavoriteIcon from '@mui/icons-material/Favorite'

import {closeSnackbar} from 'notistack'



const cssStyles = ({isExtraSmallScreen, isMediumScreen}) => ({
  root: css`
    display: flex;
    flex-direction: column;
  `,
  dayAndMonth: css`
    font-size: 0.85rem;
    color: #303030;
    text-transform: uppercase;
    letter-spacing: ${isExtraSmallScreen ? '-0.01rem' : '0.1rem'};
    text-align: center;
  `,
  number: css` 
    font-size: ${isExtraSmallScreen ? '1.5rem' : '1.8rem'};
    font-weight: 900;
    line-height: 1;
    font-family: 'Gravity';
    text-align: center;
    vertical-align: middle;
    margin-top: 2px;
  `
})





const MapListItemDate = props => {

  const navigate = useNavigate()

  const isMediumScreen = useMediaQuery(theme => theme.breakpoints.down('md'))
  const isExtraSmallScreen = useMediaQuery(theme => theme.breakpoints.only('xs'))


  const styles = cssStyles({isExtraSmallScreen, isMediumScreen})


  const {
    date,
    create,
    destroy,
    showAlert,
    performanceId,
    isAuthenticated,
    favoritePerformances,
  } = props


  const isFavorited = performanceId in favoritePerformances



  function navigateToSignupPage() {
    navigate('/sign-up')
  }



  function handleClick(e) {
    e.stopPropagation()
    e.preventDefault()


    if (!isAuthenticated) {
      const action = snackbarID => (
        <>
          <Button 
            variant='text' 
            sx={{
              fontWeight: 600,
              color: 'rgb(62, 166, 255)'
            }}
            onClick={navigateToSignupPage}
          >
            Sign Up
          </Button>

          <IconButton 
            aria-label='close'
            sx={{
              fontWeight: 600,
              color: '#fff'
            }}
            onClick={() => closeSnackbar(snackbarID)}
          >
            <CloseIcon fontSize='small' />
          </IconButton>
        </>
      )

      showAlert('Sign up to add this event to your favorites', 'standard', action)
      return
    }

    

    if (isFavorited) {
      const favoriteId = favoritePerformances[performanceId]?.id

      destroy('/favorites/' + favoriteId, 'FAVORITE').catch(error => {
        showAlert('Something went wrong', 'error')
      })
    } else {
      create('/favorites/performance/' + performanceId, 'FAVORITE')
    }
  }




  return (
    <div css={styles.root}>
      <div>
        <p css={styles.dayAndMonth}>
          {day(date, 'eee')}
        </p>

        <h3 css={styles.number}>
          {formatDate(date, 'd')}
        </h3>

        <p css={styles.dayAndMonth}>
          {formatDate(date, 'MMM')}
        </p>
      </div>

      <div>
        <IconButton aria-label='favorite' onClick={handleClick} size='large'>
          <FavoriteIcon style={{color: isFavorited ? '#ff0055' : '#9d9d9d'}} />
        </IconButton>
      </div>
    </div>
  )
}



const mapStateToProps = state => {
  return {
    isAuthenticated: state.user.isAuthenticated,
    favoritePerformances: state.user.favorites.performances
  }
}


const actions = {create, destroy, showAlert}


export default connect(mapStateToProps, actions)(MapListItemDate)


